"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const PartnerPrograms = ({ programme }) => {

    const logos = Array.isArray(programme.poweredBy)
        ? programme.poweredBy
        : [programme.poweredBy];

    return (

        <div className="bg-white border-[1.13px] border-[#F3F4F6] rounded-xs overflow-hidden hover:shadow-md transition mb-5 md:mb-10">

            <Link href={programme.url} className="block">
                <div className="relative w-full h-60">
                    <Image
                        src={programme.image || "/placeholder.jpg"}
                        alt={programme.title}
                        fill
                        className="object-cover"
                    />
                </div>
            </Link>

            <div className="p-4">
                <Link
                    href={programme.url}
                    className="text-black hover:text-[#FC9D00] transition-colors duration-300 ease-in-out"
                >
                    <h3 className="text-[16px] font-semibold mb-3 line-clamp-2 min-h-12">
                        {programme.title}
                    </h3>
                </Link>
                <div className="text-sm text-gray-500 mb-1">
                    Industry Skilling Partner
                </div>

                <div className="flex items-center gap-2 flex-wrap">

                    {logos.map((logo, index) => (

                        <div
                            key={index}
                            className="relative h-5 w-25"
                        >
                            <Image
                                src={logo}
                                alt="partner-logo"
                                className="object-contain h-5 w-auto"
                            />
                        </div>

                    ))}

                </div>

            </div>

        </div>

    );
};

export default PartnerPrograms;